import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CheckboxWidget(props) {
  var schema = props.schema,
    id = props.id,
    value = props.value,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    label = props.label,
    autofocus = props.autofocus,
    onChange = props.onChange,
    registry = props.registry;
  return /*#__PURE__*/_jsxs("div", {
    className: "form-check",
    children: [schema.description && /*#__PURE__*/_jsx(registry.fields.DescriptionField, {
      description: schema.description
    }), /*#__PURE__*/_jsx("div", {
      className: "checkbox checkbox-autoheight".concat(disabled || readonly ? " disabled" : "").concat(value ? " selected" : ""),
      onClick: function onClick() {
        onChange(!value);
      },
      children: /*#__PURE__*/_jsx("label", {
        style: {
          lineHeight: "1em"
        },
        children: label
      })
    })]
  });
}
export default CheckboxWidget;
//# sourceMappingURL=CheckboxWidget.js.map